import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Nirgam_Utara.css"; // Create a CSS file for styling
import { baseUrl, formatDateToDDMMYYYY, currentDate } from "../../Utility/constants";
import axios from "axios";

const Nirgam_Utara = () => {
  const { studentId } = useParams();
  const [schoolId, setSchoolId] = useState("");
  const [certificateData, setCertificateData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);

  useEffect(() => {
    const fetchCertificateData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/PersonalDetails/ReturnStudentDetails?studentId=${studentId}`
        );
        if (response && response.data) {
          setCertificateData(response.data);
          if (response.data.schoolId) setSchoolId(response.data.schoolId);
        }
      } catch (error) {
        console.log(
          "Failed to fetch student details. Please try again.",
          error
        );
      }
    };

    fetchCertificateData();
  }, []);

  useEffect(() => {
    if (schoolId) {
      const fetchSchoolData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
          );
          if (response && response.data) {
            setSchoolData(response.data);
          }
        } catch (error) {
          console.log(
            "Failed to fetch student details. Please try again.",
            error
          );
        }
      };
      fetchSchoolData();
    }
  }, [schoolId]);

  return (
    <>
      <div
        className="col-md-12 mt-2"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <h3 style={{ fontWeight: "bold", marginTop: "5px" }}>
          विद्यार्थी प्रवेश निर्गम प्रमाणे नोंदणी रजिस्टर
        </h3>
      </div>

      <table className="mb-2" style={{ border: "2px solid white", marginTop: "50px", width: "100%",tableLayout: "fixed" }}>
        <tr>
          <td colSpan={2} className="col-md-8" style={{ textAlign: "left", border: "2px solid white" }}>
            शाळेचे नांव : {schoolData.schoolOrCollegeName}
          </td>
        </tr>
        <tr>
          <td
            className="col-md-6"
            style={{
              textAlign: "left",
              border: "2px solid white"        
            }}
          >
            तालुका : {schoolData.taluka}
          </td>
          <td
            className="col-md-6"
            style={{
              textAlign: "right",
              whiteSpace: "nowrap",
              wordBreak: "keep-all",
              verticalAlign: "top"
            }}
          >
            जिल्हा : {schoolData.city}
          </td>
        </tr>
      </table>


      <table>
        <tr>
          <td className="number-column" colSpan={"5"}></td>
          <td
            className="number-column"
            colSpan={"2"}
            style={{
              whiteSpace: "nowrap",
              textAlign: "center",
              border: "1px solid black",
            }}
          >
            जन्म दिनांक
          </td>
          <td className="number-column" colSpan={"12"}></td>
        </tr>
        <tr>
          <th className="vertical-text">प्रवेश अनुक्रमांक`</th>
          <th className="vertical-text">
            विद्यार्थ्`यचे संपूर्ण नाव आडनांवासह
          </th>
          <th className="vertical-text">
             वडिलांचे व आईचे नाव (वडील<br></br>हयात नसल्यास पालकांचे
            नाव)
          </th>
          <th className="vertical-text">वडील / पालकांचा व्यवसाय</th>
          <th className="vertical-text">मातृभाषा</th>
          <th className="vertical-text">अंकात</th>
          <th className="vertical-text">अक्षरात</th>
          <th className="vertical-text">प्रवेश समयी वर्ग</th>
          <th className="vertical-text">पूर्वीच्या शाळेचे नाव</th>
          <th className="vertical-text">इयत्ता</th>
          <th className="vertical-text">
            प्रवेश देणाऱ्या <br></br>अधिकार्याची सही
          </th>
          <th className="vertical-text">निर्गम समयी वर्ग</th>
          <th className="vertical-text">निर्गम दिनांक</th>
          <th className="vertical-text">शाळा सोडल्याचे कारण</th>
          <th className="vertical-text">
            परिचय चिन्ह विद्यार्थ्याचे <br></br>(थोडक्यात दोन चिन्ह नोंदवावे)
          </th>
          <th className="vertical-text">
            निर्गम समयी निर्गमाची नोंद <br></br>घेणाऱ्या अधिकार्याची सही
          </th>
          <th className="vertical-text">मुख्याध्यापकाची स्वाक्षरी</th>
          <th className="vertical-text">विवरण</th>
        </tr>
        <tr>
          <td className="number-column">१</td>
          <td className="number-column">२</td>
          <td className="number-column">३</td>
          <td className="number-column">४</td>
          <td className="number-column">५</td>
          <td className="number-column">६</td>
          <td className="number-column">७</td>
          <td className="number-column">८</td>
          <td className="number-column">९</td>
          <td className="number-column">१०</td>
          <td className="number-column">११</td>
          <td className="number-column">१२</td>
          <td className="number-column">१३</td>
          <td className="number-column">१४</td>
          <td className="number-column">१५</td>
          <td className="number-column">१६</td>
          <td className="number-column">१७</td>
          <td className="number-column">१८</td>
        </tr>
        <tr>
          <td className="vertical-text">१</td>
          <td className="vertical-text">
            {certificateData.firstName +
              " " +
              certificateData.middleName +
              " " +
              certificateData.lastName}
          </td>
          <td className="vertical-text">{certificateData.middleName}</td>
          <td className="vertical-text">{certificateData.parentOccupation}</td>
          <td className="vertical-text">{certificateData.motherTongue}</td>
          <td className="vertical-text">
            {certificateData.dateOfBirth &&
              formatDateToDDMMYYYY(certificateData.dateOfBirth.split("T")[0])}
          </td>
          <td className="vertical-text">
            {certificateData.dateOfBirthInWords}
          </td>
          <td className="vertical-text">{certificateData.standardName}</td>
          <td className="vertical-text">
            {certificateData.previousSchoolName}
          </td>
          <td className="vertical-text">{certificateData.previousStandard}</td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
          <td className="vertical-text"></td>
        </tr>
      </table>

      <table className="mb-2" style={{ border: "2px solid white", marginTop: "50px" }}>
        <tr>
          <td className="col-md-8" style={{ textAlign: "left", border: "2px solid white" }}>दिनांक :-  {currentDate()}<br></br>
            स्थळ  :-
          </td>
          <td className="col-md-4" style={{ textAlign: "right" }}>मुख्याध्यापक/प्राचार्य स्वाक्षरी</td>
        </tr>
      </table>

    </>
  );
};

export default Nirgam_Utara;
